import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
